<template>
<div>
    <div ref="head">
        <div v-if="$slots.header" :style="myConfig.headStyle">
            <slot name="header"></slot>
        </div>
        <Row  v-if="showCondition">
            <Col span='24'>
                    <ConditionBox  ref="condition" :config="myConfig"  @conditionAction="conditionAction"  :dictData="dictData" :isPop="isPop"></ConditionBox>
            </Col>
        </Row>
    </div>
    <template v-if="!myConfig.multiSelectGrid">
        <Card :padding="0" :bordered="false"  dis-hover>
        <Table ref="table"  :row-class-name="myConfig.rowClassName" :loading="loading"  :show-summary="myConfig.showSummary"  :summary-method="handleSummary"  :size="myConfig.tableSize"  :stripe="myConfig.showStripe" :border="myConfig.showBorder" :height="tableHeight" :max-height="tableMaxHeight" :show-header="myConfig.showHeader" :columns="tableColumns"  :data="tempData" @on-sort-change="sortChagne"  @on-current-change="onCurrentChange" :highlight-row="myConfig.highLightRow" @on-row-dblclick="dbclick"  @on-select="onSelect" @on-select-cancel="onSelectCancel" @on-selection-change="OnSelectionChange" @on-row-click="click"  @on-column-width-resize="onColumnWidthResize">
         <template  v-for="config in soltTableColumns" slot-scope="{ row, index }" :slot="config.key">          
               <ShowText :label="formatValue(index,config)"  :contentAlign="config.contentAlign" :class="config.cellClassName" ></ShowText>
         </template>
        </Table>
        </Card>
         <div v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
        <div ref="page" name="page">
            <div  v-if="myConfig.showPage"  style="padding-top:10px;" >
                <Card :bordered="false" :padding="0" :dis-hover="true" style="border-radius:0px">
                    <Row  type="flex" justify="end" style="padding-right:10px">
                        <PageCustom  :total="myConfig.pageConfig.total_results"  :size="myConfig.pageSize"  :current="myConfig.pageConfig.page_no" :page-size="myConfig.pageConfig.page_size" :page-size-opts="myConfig.pageConfig.pageSizeList"  @on-page-size-change="changePageSize" @on-change="changePage"  :show-total="myConfig.pageShowTotal" :show-elevator="myConfig.pageShowElevator" :show-sizer="myConfig.pageShowSizer"></PageCustom>
                    </Row>
                </Card>
            </div>
        </div>
    </template>
    <template v-else>
        <Row type="flex" justify="center" align="middle" >
            <Col :span="gridCol">
                <Card :padding="0"  bordered dis-hover>
                    <span slot="title" v-text="myConfig.gridTitle"></span>
                    <Table ref="table"  :row-class-name="myConfig.rowClassName"  :show-summary="myConfig.showSummary" :summary-method="handleSummary"  :loading="loading" :size="myConfig.tableSize"  :stripe="myConfig.showStripe" :border="myConfig.showBorder" :height="tableHeight" :max-height="tableMaxHeight":show-header="myConfig.showHeader" :columns="tableColumns"  :data="tempData" @on-sort-change="sortChagne"  @on-current-change="onCurrentChange" :highlight-row="myConfig.highLightRow" @on-row-dblclick="dbclick"  @on-select="onSelect" @on-select-cancel="onSelectCancel" @on-selection-change="OnSelectionChange" @on-row-click="click" @on-column-width-resize="onColumnWidthResize">
                         <template   v-for="config in soltTableColumns" slot-scope="{ row, index }" :slot="config.key">
                            <ShowText  :label="formatValue(index,config)"  :contentAlign="config.contentAlign" :class="config.cellClassName" ></ShowText>
                         </template>
                    </Table>
                </Card>
            </Col>
            <Col span= '2'>
                  <Row  type="flex" justify="center" align="middle" style="padding:5px;" >
                        <Tooltip content="删除" placement="left">
                           <Button type="primary" size="small"  icon="ios-arrow-back" :disabled="!rightActive" @click="moveToLeft"></Button>
                        </Tooltip>
                  </Row>
                  <Row  type="flex" justify="center" align="middle" style="padding:5px;" >
                       <Tooltip content="添加" placement="right">
                            <Button type="primary" size="small"  icon="ios-arrow-forward" :disabled="!leftActive" @click="moveToRight"></Button>
                        </Tooltip>
                  </Row>
            </Col>
            <Col :span="multiGridCol">
                <Card :padding="0" :bordered="false">
                     <span slot="title" v-text="myConfig.multiGridTitle"></span>
                     <Table ref="multiSelectTable"  :row-class-name="myConfig.rowClassName"  :size="myConfig.tableSize"  :stripe="myConfig.showStripe" :border="myConfig.showBorder" :height="tableHeight" :max-height="tableMaxHeight" :show-header="myConfig.showHeader" :columns="multiTableColumns"  :data="tempMultiSelectData" :highlight-row="myConfig.highLightRow" @on-selection-change="OnMultiSelectionChange">
                         <template  v-for="config in multiSoltTableColumns" slot-scope="{ row, index }" :slot="config.key">
                            <ShowText  :label="formatMulValue(index,config)"  :contentAlign="config.contentAlign" ></ShowText>
                         </template>
                     </Table>
                </Card>
            </Col>
        </Row>
         <div ref="page" name="page">
         <div v-if="$slots.footer">
                <slot name="footer"></slot>
        </div>
        <div  v-if="myConfig.showPage" ref="page" style="padding-top:10px;">
            <Card :bordered="false" :padding="0" :dis-hover="true"  style="border-radius:0px">
                 <Row  type="flex" justify="start" style="padding-right:10px" :gutter="0">
                     <PageCustom  :total="myConfig.pageConfig.total_results"  :size="myConfig.pageSize"  :current="myConfig.pageConfig.page_no" :page-size="myConfig.pageConfig.page_size" :page-size-opts="myConfig.pageConfig.pageSizeList"  @on-page-size-change="changePageSize" @on-change="changePage"  :show-total="myConfig.pageShowTotal" :show-elevator="myConfig.pageShowElevator" :show-sizer="myConfig.pageShowSizer"></PageCustom>
                </Row>
            </Card>
        </div>
        </div>
    </template> 
</div>
</template>
<script>
import Base from '@/components/grid/viewgridbase.vue';
export default {
    name: 'simpleviewgrid',
    extends: Base,
    methods: {
        customInit() {
            if (this.myConfig.pageSizeNum) {
                this.myConfig.pageConfig.page_size = Number(this.myConfig.pageSizeNum);
            }
            if (this.myConfig.dynamicColumnFlag) {
                this.myConfig.showPage = false;
            }
        },
        initCheckColumn(columns) {
            if (this.myConfig.showCheckBox) {
                let check = {};
                check.type = 'selection';
                check.align = 'center';
                check.width = 40;
                check.multiSelect = this.myConfig.multiSelect;
                columns.push(check);
            }
        },
        initIndexColumn(columns) {
            if (this.myConfig.showIndex) {
                let index = {};
                index.type = 'index';
                index.key = 'index';
                index.width = 50;
                index.title = '行号';
                index.align = 'center';
                if (this.myConfig.headClassName !== undefined) {
                    index.className  = this.myConfig.headClassName;
                }
                index.indexMethod = this.indexRender;
                if (this.myConfig.indexConfig !== undefined) {
                    Object.assign(index, this.myConfig.indexConfig);
                }
                columns.push(index);
            }
        },
    },
    mounted () {  
    }
};
</script>


// WEBPACK FOOTER //
// src/components/masterplate/simpleviewgrid.vue